export default "__VITE_ASSET__Drj3eWUE__"